import { version } from '../../../package.json';
import axios from 'axios';
import { settings } from './Requests';

// Типы для событий
interface AnalyticsEvent {
  timestamp: number;
  type: string;
  value: string;
  [key: string]: any;
}

interface AnalyticsPayload {
  events: AnalyticsEvent[];
  app_version: string;
}

class AnalyticsService {
  private events: AnalyticsEvent[];
  private isInitialized: boolean;
  private readonly batchSize: number;
  private readonly flushInterval: number;
  private flushTimeoutId?: NodeJS.Timeout;

  constructor() {
    this.events = [];
    this.isInitialized = false;
    this.batchSize = 10;
    this.flushInterval = 30000;
  }

  public init(): void {
    if (this.isInitialized) return;

    const tg = window.Telegram.WebApp;

    // 1. Событие viewportChanged - срабатывает когда пользователь 
    // сворачивает приложение свайпом или через кнопку
    tg.onEvent('viewportChanged', () => {
      if (!tg.isExpanded) {
        console.log('TMA свернуто через viewportChanged');
        this.flush();
      }
    });

    // 2. Событие close - срабатывает при полном закрытии приложения
    tg.onEvent('close', () => {
      console.log('TMA закрыто через close event');
      this.flush();
    });

    // 3. Событие backButtonClicked - срабатывает при нажатии 
    // кнопки "Назад" в шапке TMA
    tg.onEvent('backButtonClicked', () => {
      console.log('TMA: нажата кнопка "Назад"');
      this.flush();
    });

    // 4. Событие visibilitychange - срабатывает когда пользователь 
    // переключается между приложениями
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        console.log('TMA потеряло фокус (переключение на другое приложение)');
        this.flush();
      }
    });

    this.startFlushInterval();
    this.isInitialized = true;
  }

  private startFlushInterval(): void {
    this.flushTimeoutId = setInterval(() => {
      this.flush();
    }, this.flushInterval);
  }

  public trackEvent(type: string, value: string, additionalProps: Record<string, any> = {}): void {
    const event: AnalyticsEvent = {
      timestamp: Math.floor(Date.now() / 1000),
      type,
      value,
      ...additionalProps
    };

    this.events.push(event);

    if (this.events.length >= this.batchSize) {
      this.flush();
    }
  }

  public async flush(): Promise<void> {
    if (this.events.length === 0) return;

    const payload: AnalyticsPayload = {
      events: [...this.events],
      app_version: version
    };

    try {
      console.log('Отправка аналитики при закрытии/сворачивании:', {
        eventCount: this.events.length,
        payload
      });
      
      await axios.post(`${settings.url}api/users/action`, payload);
      console.log('Аналитика успешно отправлена');
      
      this.events = [];
    } catch (error) {
      console.error('Ошибка при отправке аналитики:', error);
    }
  }

  public destroy(): void {
    if (this.flushTimeoutId) {
      clearInterval(this.flushTimeoutId);
    }
    this.flush();
  }
}

export const analytics = new AnalyticsService(); 